import { useFindAssetIdForWorkspace } from '@gripp/shared-logic';
import { LoadingIndicator, SlideLayout, ViewMode } from '@gripp/shared-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { AssetRouteProvider } from '../../assets/assetRouteContext';
import { AssetCard } from '../../assets/components/assetCard';
import { AssetFilters } from '../../assets/components/assetFilters';
import { Issue } from '../../issues/components/issue';

export const WorkspaceActivity = () => {
  const { workspaceId = '' } = useParams();
  const navigate = useNavigate();
  const { assetId, isLoading } = useFindAssetIdForWorkspace(workspaceId);

  const routeContext = {
    basePath: `/workspaces/${workspaceId}`,
    listPath: '/workspaces',
    isWorkspaceMode: true,
  };

  const leftColumn = {
    title: 'admin.menu.workspaces',
    mainComponent: isLoading ? (
      <LoadingIndicator />
    ) : assetId ? (
      <AssetRouteProvider value={routeContext}>
        <AssetCard assetId={assetId} />
      </AssetRouteProvider>
    ) : null,
    headerComponent:
      !isLoading && assetId ? (
        <AssetRouteProvider value={routeContext}>
          <AssetFilters assetId={assetId} />
        </AssetRouteProvider>
      ) : null,
    showBackButton: true,
    disableScroll: true,
    onBackButtonPress: () => {
      navigate(`/workspaces/${workspaceId}`);
    },
  };

  const rightColumn = {
    title: 'admin.menu.workspaces',
    showHeader: false,
    disableScroll: true,
    mainComponent: <Issue />,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
